import PATHS from 'src/router/paths'

const iconLogoOnLight = require('src/assets/images/adops-logo-with-blue-glow-on-white-transparency.png')
const iconLogoOnDark = require('src/assets/images/adops-logo-with-blue-glow-on-black-transparency.png')

const iconDefaultAvatar = require('src/assets/images/default-avatar.png')

const iconDashboard = require('src/assets/images/Home_64x64.png')
const iconDocs = require('src/assets/images/User_Docs_64x64.png')
const iconDocsPages = require('src/assets/images/User_Docs_Pages_64x64.png')

const iconTime = require('src/assets/images/time.png')
const iconOrg = require('src/assets/images/Organization_64x64.png')
const iconPerson = require('src/assets/images/person-circled.png')
const iconProject = require('src/assets/images/Project_64x64.png')

const iconPacing = require('src/assets/images/Pacing_64x64.png')
const iconDiscrepancy = require('src/assets/images/Discrepancy_64x64.png')

const iconAlpha = require('src/assets/images/Alpha_64x64.png')
const iconProgrammatic = require('src/assets/images/Programmatic_64x64.png')
const iconNetworkHealth = require('src/assets/images/NetworkHealth_64x64.png')

const iconCustomReports = require('src/assets/images/CustomReport_64x64.png')

const iconAdminSettings = require('@/assets/images/admin-settings.png')
const iconSettings = require('@/assets/images/settings.png')

const icons = {
  navigation: {
    // Avatars
    defaultAvatar: iconDefaultAvatar,

    // Logos
    logo: iconLogoOnLight,
    logoDarkMode: iconLogoOnDark,
    logoLightMode: iconLogoOnLight,

    // Navigation Menu Items
    dashboard: iconDashboard,
    doc: iconDocsPages,
    docs: iconDocs,
    organization: iconOrg,
    organizations: iconOrg,
    people: iconPerson,
    person: iconPerson,
    project: iconProject,
    projects: iconProject,
    [PATHS.CUSTOM_REPORTS.BASE]: iconCustomReports,
    time: iconTime,

    [PATHS.ACCOUNT.BASE]: iconSettings,
    [PATHS.ADMIN.BASE]: iconAdminSettings,
    [PATHS.SETTINGS.BASE]: iconSettings,

    [PATHS.REPORTS.PROGRAMMATIC]: iconProgrammatic,

    [PATHS.REPORTS.DISCREPANCY]: iconDiscrepancy,
    [PATHS.REPORTS.PACING]: iconPacing,
    [PATHS.REPORTS.ADX_HEALTH]: iconAlpha,
    [PATHS.REPORTS.NETWORK_HEALTH]: iconNetworkHealth,
    [PATHS.REPORTS.YIELD_PARTNER]: iconProgrammatic,

    add: {
      doc: iconDocsPages,
      docs: iconDocs,
      organization: iconOrg,
      organizations: iconOrg,
      [PATHS.REPORTS.ADX_HEALTH]: iconAlpha,
      [PATHS.REPORTS.NETWORK_HEALTH]: iconNetworkHealth,
      [PATHS.REPORTS.YIELD_PARTNER]: iconAlpha,
      people: iconPerson,
      person: iconPerson,
      project: iconProject,
      projects: iconProject,
      time: iconTime,
    },
  },
  stateful: {
    defaults: {
      color: 'coolgray',
      icon: 'circle',
    },
    error: {
      color: 'toasted',
      icon: 'circle',
    },
    loading: {
      color: 'coolgray',
      icon: 'autorenew',
    },
    recovering: {
      color: 'toasted',
      icon: 'autorenew',
    },
    refreshing: {
      color: 'blue',
      icon: 'autorenew',
    },
    success: {
      color: 'offblue',
      icon: 'circle',
    },
  },
  values: {
    false: {
      color: 'toasted',
      icon: 'indeterminate_check_box',
    },
    true: {
      color: 'offblue',
      icon: 'check_box',
    },
    'n/a': {
      color: 'midgray',
      icon: 'indeterminate_check_box',
    },
    null: {
      color: 'midgray',
      icon: 'check_box_outline_blank',
    },
    undefined: {
      color: 'midgray',
      icon: 'check_box_outline_blank',
    },
  },
}

export default icons
